(() => {
  const root = document.getElementById('artapli-menu-v2');
  if (!root) return;
  /* i18n 2026-09-26: UI strings come from the snippet's JSON block (theme locale keys artapli_menu.js.*).
     Missing block or key -> the English fallback written here. */
  const I18N = (() => { try { const el = document.getElementById('artapli-menu-i18n'); return el ? JSON.parse(el.textContent) : {}; } catch (error) { return {}; } })();
  /* i18n phase 3: locale root from the JSON block ("/" on en -> LP is '' and every link stays as it was).
     loc() prefixes only root-relative store paths, never an already prefixed or external URL. */
  const LP = (() => { const r = typeof I18N.locale_root === 'string' ? I18N.locale_root : '/'; return r === '/' || r.charAt(0) !== '/' ? '' : r.replace(/\/+$/, ''); })();
  const loc = (url) => {
    if (!LP || typeof url !== 'string') return url;
    if (url.indexOf('/apps/artapli-studio/studio-entry') === 0) {
      try {
        const target = new URL(url, location.origin);
        const back = target.searchParams.get('return_path') || '/library/';
        if (!/[?&]lang=/.test(back)) {
          target.searchParams.set('return_path', back + (back.includes('?') ? '&' : '?') + 'lang=' + LP.slice(1, 3));
        }
        return target.pathname + target.search + target.hash;
      } catch (error) { return url; }
    }
    return /^\/(collections|pages|products|search|cart|account|blogs)(\/|\?|#|$)/.test(url) ? LP + url : url;
  };
  const decodeText = value => { const area = document.createElement('textarea'); area.innerHTML = value; return area.value; };
  const tr = (key, fallback, vars) => {
    let value = typeof I18N[key] === 'string' && I18N[key] && I18N[key].indexOf('translation missing') !== 0 ? decodeText(I18N[key]) : fallback;
    if (vars) Object.keys(vars).forEach(name => { value = value.split('{' + name + '}').join(vars[name]); });
    return value;
  };
  const trh = (key, fallback) => String(tr(key, fallback)).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  /* Menu buttons, 2026-09-15: the card buttons draw their arrow in CSS, so remove the typed one. */
  root.querySelectorAll('.app-card > strong, .spotlight .quiet-link').forEach(cta => {
    cta.textContent = cta.textContent.replace(/\s*→\s*$/, '');
  });
  root.dataset.menuCta = 'icon';
  // The desktop cards are server-rendered before this file runs. Normalize them
  // through the same locale function used by generated mobile and taxonomy links.
  root.querySelectorAll('a[href]').forEach((link) => {
    const current = link.getAttribute('href');
    const localized = loc(current);
    if (localized && localized !== current) link.setAttribute('href', localized);
  });

  /* The canonical header owns storefront search; remove the old homepage-only duplicate. */
  document.querySelectorAll('#MainContent [id^="Search-In-Home-Long"]').forEach(searchInput => {
    const legacySearchSection = searchInput.closest('.shopify-section');
    if (legacySearchSection) legacySearchSection.hidden = true;
  });

  /* Some theme search code clears hidden scope values during hydration.
     Restore product-only scope now and again at submit time. */
  root.querySelectorAll('form.search').forEach(form => {
    const enforceProductScope = () => {
      let scope = form.querySelector('input[name="type"]');
      if (!scope) {
        scope = document.createElement('input');
        scope.type = 'hidden';
        scope.name = 'type';
        form.appendChild(scope);
      }
      scope.value = 'product';
      scope.setAttribute('value', 'product');
    };
    enforceProductScope();
    form.addEventListener('submit', enforceProductScope, { capture: true });
    form.addEventListener('formdata', event => event.formData.set('type', 'product'));
  });

  function openPanel(name) {
    root.querySelectorAll('[data-panel]').forEach(panel => panel.classList.toggle('open', panel.dataset.panel === name));
    root.querySelectorAll('[data-target]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.target === name)));
    root.querySelector('.desktop .mega')?.classList.toggle('has-open-panel', Boolean(name));
  }
  root.querySelectorAll('[data-target]').forEach(button => button.addEventListener('click', () => {
    openPanel(button.getAttribute('aria-expanded') === 'true' ? null : button.dataset.target);
  }));
  const mobile = root.querySelector('.mobile');
  const mobileToggle = root.querySelector('[data-mobile-menu-toggle]');
  const mobileSearchToggle = root.querySelector('[data-mobile-search-toggle]');
  const mobileAccountToggle = root.querySelector('[data-mobile-account-toggle]');
  const setMobileMenu = open => {
    mobile?.classList.toggle('is-menu-open', open);
    if (open) mobile?.classList.remove('is-search-open');
    mobileToggle?.setAttribute('aria-expanded', String(open));
    mobileToggle?.setAttribute('aria-label', open ? tr('close_menu', 'Close menu') : tr('open_menu', 'Open menu'));
    mobileSearchToggle?.setAttribute('aria-expanded', 'false');
  };
  mobileToggle?.addEventListener('click', () => setMobileMenu(!mobile?.classList.contains('is-menu-open')));
  mobileSearchToggle?.addEventListener('click', () => {
    const open = !mobile?.classList.contains('is-search-open');
    setMobileMenu(false);
    mobile?.classList.toggle('is-search-open', open);
    mobileSearchToggle.setAttribute('aria-expanded', String(open));
    if (open) root.querySelector('.mobile-search input[type="search"]')?.focus();
  });
  mobileAccountToggle?.addEventListener('click', () => {
    setMobileMenu(true);
    requestAnimationFrame(() => {
      const accountHeading = [...root.querySelectorAll('.mobile-hub-head h2')].find(heading => heading.textContent.trim() === tr('account', 'Account'));
      accountHeading?.closest('.mobile-hub')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  });
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      openPanel(null);
      setMobileMenu(false);
      mobile?.classList.remove('is-search-open');
      mobileSearchToggle?.setAttribute('aria-expanded', 'false');
    }
  });

  /* Shop, 2026-09-15 (Anna): the opened category's columns start under its own tile and run right.
     With no room left they keep every column and stick to the right edge of the tile row. */
  function alignTaxonomyColumns(shop) {
    const tabs = shop.querySelector('.taxonomy-tabs');
    const body = shop.querySelector('[data-taxonomy-body]');
    const tab = tabs && tabs.querySelector('[aria-selected="true"]');
    if (!tab || !body) return;
    const tabsBox = tabs.getBoundingClientRect();
    const tabsStyle = getComputedStyle(tabs);
    const room = parseFloat(tabsStyle.width);
    if (!tabsBox.width || !room) return;
    const toLocal = room / tabsBox.width;
    const bodyStyle = getComputedStyle(body);
    const cssPx = name => parseFloat(bodyStyle.getPropertyValue(name)) || 0;
    const maxCols = parseInt(bodyStyle.getPropertyValue('--taxonomy-max-cols'), 10) || 4;
    const cols = Math.max(1, Math.min(maxCols, body.children.length));
    const colGap = parseFloat(bodyStyle.columnGap) || 0;
    const tabGap = parseFloat(tabsStyle.columnGap) || 0;
    const tabBox = tab.getBoundingClientRect();
    const start = (tabBox.left - tabsBox.left) * toLocal;
    /* At least as wide as the tiles the columns sit under (and a readable column); at most the
       original panel width. From the opened tile it fills what is left of the row. */
    const tileSpan = cols * tabBox.width * toLocal + (cols - 1) * tabGap;
    const least = Math.min(room, Math.max(tileSpan, cols * (cssPx('--taxonomy-min-col') || 200) + (cols - 1) * colGap));
    const ideal = Math.max(least, cols * (cssPx('--taxonomy-ideal-col') || 275) + (cols - 1) * colGap);
    const width = room - start + 1 >= least ? Math.min(ideal, room - start) : least;
    body.style.setProperty('--taxonomy-cols', String(cols));
    body.style.width = width + 'px';
    body.style.marginLeft = Math.max(0, Math.min(start, room - width)) + 'px';
  }

  async function boot() {
    const fetchMenu = src => fetch(src, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    let response = await fetchMenu(root.dataset.menuSrc);
    /* i18n phase 3: a missing language contract falls back to the English one */
    if (!response.ok && root.dataset.menuFallback) response = await fetchMenu(root.dataset.menuFallback);
    if (!response.ok) throw new Error(`Menu contract request failed: ${response.status}`);
    const menu = await response.json();
    const featureImages = {};
    const shop = root.querySelector('[data-panel="shop"]');
    const count = node => node.taxonomy_projection?.distinct_sku_count;
    const countHtml = node => Number.isInteger(count(node)) ? '<span class="taxonomy-count">' + count(node).toLocaleString() + '</span>' : '';
    const href = node => loc(node.href || '#');
    const nodeImage = node => node?.image || featureImages[node?.source_ref] || featureImages[node?.label] || '';
    const surfaceRules = menu.surface_rules || {};
    const mobileRules = surfaceRules.mobile || {};
    const desktopRules = surfaceRules.desktop || {};
    const findNodeByHandle = handle => {
      const visit = nodes => {
        for (const node of nodes) {
          if (node.collection_handle === handle) return node;
          const found = visit(node.children || []);
          if (found) return found;
        }
        return null;
      };
      return visit([...(menu.utility_tree || []), ...(menu.product_tree || [])]);
    };
    /* Shop, 2026-09-15 (Anna): each sub-collection shows its own small collection picture again. It is the
       collection image already in this menu contract (node.image), resized by the Shopify CDN;
       a collection without one shows its first letter. */
    const thumbUrl = url => url + (url.includes('?') ? '&' : '?') + 'width=96';
    const taxonomyThumb = node => '<span class="taxonomy-thumb" aria-hidden="true">' + (nodeImage(node) ? '<img src="' + thumbUrl(nodeImage(node)) + '" alt="" loading="lazy" decoding="async">' : '<span>' + String(node.label || '').trim().charAt(0).toUpperCase() + '</span>') + '</span>';
    const renderBranch = branch => branch.children.filter(node => node.visibility === 'visible').map(node => {
      const children = node.children.filter(child => child.visibility === 'visible');
      if (!children.length) return '<a class="taxonomy-leaf" href="' + href(node) + '">' + taxonomyThumb(node) + '<span>' + node.label + countHtml(node) + '</span></a>';
      return '<div class="taxonomy-cluster"><a href="' + href(node) + '">' + taxonomyThumb(node) + '<span>' + node.label + '</span>' + countHtml(node) + '</a><ul>' + children.map(child => '<li><a href="' + href(child) + '">' + taxonomyThumb(child) + '<span>' + child.label + countHtml(child) + '</span></a></li>').join('') + '</ul></div>';
    }).join('');
    const desktopRootLabels = desktopRules.catalog_roots || menu.product_tree.map(node => node.label);
    const desktopRoots = desktopRootLabels.map(label => menu.product_tree.find(node => node.label === label)).filter(Boolean);
    const desktopIndexNodes = (mobileRules.shop_index || ['view-all','all-fonts']).map(findNodeByHandle).filter(Boolean);
    const desktopFeaturedNodes = (mobileRules.featured || ['new-arrivals','best-sellers','most-reviewed']).map(findNodeByHandle).filter(Boolean);
    const desktopShopIconPaths = {
      'new-arrivals':'<path d="m12 3 1.1 3.1L16 7.2l-2.9 1.1L12 11.5l-1.1-3.2L8 7.2l2.9-1.1L12 3Z"/><path d="m18.5 12 .7 2 1.8.7-1.8.7-.7 2-.7-2-1.8-.7 1.8-.7.7-2Z"/><path d="m6 13 1.1 3.1 2.9 1.1-2.9 1.1L6 21.5l-1.1-3.2L2 17.2l2.9-1.1L6 13Z"/>',
      'best-sellers':'<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"/>',
      'most-reviewed':'<path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-4 3v-3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"/><path d="M9 11c0-1.8 2.6-1.8 3 0 .4-1.8 3-1.8 3 0 0 1.8-3 3.5-3 3.5S9 12.8 9 11Z"/>'
    };
    const desktopShopIcon = handle => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (desktopShopIconPaths[handle] || '') + '</svg>';
    const desktopFeature = node => '<a class="desktop-shop-feature" href="' + href(node) + '"><span>' + desktopShopIcon(node.collection_handle) + '</span><strong>' + node.label + '</strong><span>→</span></a>';
    shop.innerHTML = '<div class="panel-title"><h2>' + trh('shop_designs', 'Shop Designs') + '</h2><span class="taxonomy-build">' + menu.build_id + '</span></div><div class="desktop-shop-index">' + desktopIndexNodes.map(node => '<a href="' + href(node) + '">' + node.label + ' →</a>').join('') + '</div><div class="desktop-shop-features">' + desktopFeaturedNodes.map(desktopFeature).join('') + '</div><div class="taxonomy-tabs" role="tablist">' + desktopRoots.map((node, index) => '<button class="taxonomy-tab" type="button" role="tab" data-taxonomy-tab="' + index + '" aria-selected="' + (index === 0) + '"><span class="taxonomy-tab-art">' + (nodeImage(node) ? '<img src="' + nodeImage(node) + '" alt="">' : '') + '</span><span class="taxonomy-tab-label"><span>' + node.label + '</span><span class="taxonomy-tab-arrow" aria-hidden="true">' + (index === 0 ? '⌄' : '›') + '</span></span></button>').join('') + '</div><div class="taxonomy-columns" data-taxonomy-body>' + renderBranch(desktopRoots[0]) + '</div>';
    shop.querySelectorAll('[data-taxonomy-tab]').forEach(button => button.addEventListener('click', () => {
      shop.querySelectorAll('[data-taxonomy-tab]').forEach(other => {
        const selected = other === button;
        other.setAttribute('aria-selected', String(selected));
        other.querySelector('.taxonomy-tab-arrow').textContent = selected ? '⌄' : '›';
      });
      shop.querySelector('[data-taxonomy-body]').innerHTML = renderBranch(desktopRoots[Number(button.dataset.taxonomyTab)]);
      alignTaxonomyColumns(shop);
    }));
    alignTaxonomyColumns(shop);
    if ('ResizeObserver' in window) new ResizeObserver(() => alignTaxonomyColumns(shop)).observe(shop.querySelector('.taxonomy-tabs'));
    else {
      window.addEventListener('resize', () => alignTaxonomyColumns(shop));
      root.addEventListener('click', () => requestAnimationFrame(() => alignTaxonomyColumns(shop)));
    }
    const mobile = root.querySelector('[data-mobile-panel="shop"]');
    const mobileNode = node => {
      const children = node.children.filter(child => child.visibility === 'visible');
      if (!children.length) return '<a href="' + href(node) + '">' + node.label + '</a>';
      return '<details><summary>' + node.label + '</summary>' + children.map(mobileNode).join('') + '</details>';
    };
    mobile.classList.add('mobile-taxonomy');
    mobile.innerHTML = menu.product_tree.map(mobileNode).join('') + '<h3>' + trh('quick_links', 'Quick links') + '</h3>' + menu.utility_tree.filter(node => node.visibility === 'visible').map(node => '<a href="' + href(node) + '">' + node.label + '</a>').join('');
    const mobileMenu = root.querySelector('.mobile-menu');
    const iconPaths = new Map([
      ['sparkles', '<path d="m12 3 1.1 3.1L16 7.2l-2.9 1.1L12 11.5l-1.1-3.2L8 7.2l2.9-1.1L12 3Z"/><path d="m18.5 12 .7 2 1.8.7-1.8.7-.7 2-.7-2-1.8-.7 1.8-.7.7-2Z"/><path d="m6 13 1.1 3.1 2.9 1.1-2.9 1.1L6 21.5l-1.1-3.2L2 17.2l2.9-1.1L6 13Z"/>'],
      ['star', '<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"/>'],
      ['type', '<path d="M5 5h14M12 5v14M8 19h8"/>'],
      ['message-square-heart', '<path d="M5 18 3 21v-5a8 8 0 1 1 4 3"/><path d="M9 11c0-2 3-2 3 0 0-2 3-2 3 0 0 2-3 4-3 4s-3-2-3-4Z"/>'],
      ['library', '<path d="m16 6 4 14"/><path d="M12 6v14"/><path d="M8 8v12"/><path d="M4 4v16"/>'],
      ['lettering', '<path d="m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284"/><path d="M3 21h18"/>'],
      ['image', '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>'],
      ['heart', '<path d="M12 20 4.8 13A4.7 4.7 0 0 1 11.4 6.3L12 7l.6-.7A4.7 4.7 0 0 1 19.2 13L12 20Z"/>'],
      ['package-check', '<path d="m4 8 8-4 8 4-8 4-8-4Z"/><path d="M4 8v8l8 4 8-4V8M12 12v8"/><path d="m15.5 15 1.2 1.2 2.3-2.7"/>'],
      ['gift', '<rect x="3" y="9" width="18" height="11"/><path d="M12 9v11M3 13h18M12 9H7.5a2.5 2.5 0 1 1 2-4c1.2 1 2.5 4 2.5 4Zm0 0h4.5a2.5 2.5 0 1 0-2-4c-1.2 1-2.5 4-2.5 4Z"/>'],
      ['images', '<rect x="5" y="3" width="16" height="14"/><path d="m6 15 4-4 3 3 3-4 4 5M3 7v14h14"/>'],
      ['lightbulb', '<path d="M9 18h6M10 21h4M8.5 15.5a6 6 0 1 1 7 0c-1 .7-1.5 1.4-1.5 2.5h-4c0-1.1-.5-1.8-1.5-2.5Z"/>'],
      ['search', '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/>'],
      ['chevron-down', '<path d="m6 9 6 6 6-6"/>'],
      ['eye', '<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.5"/>'],
      ['folder', '<path d="M3 6h7l2 2h9v11H3V6Z"/>'],
      ['zap', '<path d="m13 2-8 12h7l-1 8 8-12h-7l1-8Z"/>'],
      ['printer', '<path d="M6 9V3h12v6M6 18H4V10h16v8h-2M7 15h10v6H7v-6Z"/>'],
      ['shapes', '<circle cx="7" cy="7" r="3"/><rect x="13" y="4" width="7" height="7"/><path d="m4 20 4-7 4 7H4Z"/>'],
      ['circle-help', '<circle cx="12" cy="12" r="9"/><path d="M9.8 9a2.4 2.4 0 1 1 3.5 2.1c-.9.5-1.3 1-1.3 2M12 17h.01"/>'],
      ['user', '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>'],
      ['shopping-bag', '<path d="M4 8h16l-1 13H5L4 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/>'],
      ['message-circle', '<path d="M20 15a8 8 0 1 0-4 4l5 2-1-6Z"/>'],
      ['mail', '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/>'],
      ['info', '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/>'],
      ['newspaper', '<path d="M4 4h14v16H4V4Z"/><path d="M8 8h6M8 12h6M8 16h4"/>'],
      ['book-open', '<path d="M3 5c4-1 7 0 9 2v13c-2-2-5-3-9-2V5Zm18 0c-4-1-7 0-9 2v13c2-2 5-3 9-2V5Z"/>'],
      ['arrow-right', '<path d="M5 12h14M14 7l5 5-5 5"/>'],
      ['hoop', '<rect x="4" y="6" width="16" height="13" rx="2"/><path d="M9 6V3h6v3"/>'],
      ['scissors', '<circle cx="6" cy="7" r="3"/><circle cx="6" cy="17" r="3"/><path d="m8.5 8.5 11 6M8.5 15.5l11-6"/>'],
      ['calendar', '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4M17 3v4M3 10h18"/>']
      ,['palette', '<path d="M3 4h9M3 20h9M4.5 4v16M10.5 4v16"/><path d="m4.5 9.5 6-2.5M4.5 14l6-2.5M4.5 18.5l6-2.5"/><circle cx="17.5" cy="6" r="2.4"/><circle cx="17.5" cy="12" r="2.4"/><circle cx="17.5" cy="18" r="2.4"/>']
      ,['close', '<path d="m6 6 12 12M18 6 6 18"/>']
      ,['menu', '<path d="M4 7h16M4 12h16M4 17h16"/>']
    ]);
    const iconSvg = name => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (iconPaths.get(name) || '') + '</svg>';

    const iconAliases = new Map([
      ['x', 'close'], ['chevron-up', 'chevron-down'], ['folder-archive', 'folder'],
      ['user-round', 'user']
    ]);
    root.querySelectorAll('[data-lucide]').forEach(placeholder => {
      const requested = placeholder.dataset.lucide;
      const icon = iconSvg(iconAliases.get(requested) || requested);
      if (!iconPaths.has(iconAliases.get(requested) || requested)) return;
      const holder = document.createElement('span');
      holder.innerHTML = icon;
      const svg = holder.firstElementChild;
      if (placeholder.className) svg.setAttribute('class', placeholder.className);
      if (requested === 'chevron-up') svg.style.transform = 'rotate(180deg)';
      placeholder.replaceWith(svg);
    });

    const explore = root.querySelector('[data-panel="explore"]');
    const accountActions = root.querySelector('[data-panel="account"] .account-actions');
    accountActions.insertAdjacentHTML('beforeend', '<a class="account-action" href="' + LP + '/pages/subscribe">' + iconSvg('mail') + '<strong>' + trh('subscribe', 'Subscribe') + '</strong></a>');
    const newArrivals = findNodeByHandle('new-arrivals');
    const bestSellers = findNodeByHandle('best-sellers');
    const productShelf = node => {
      const products = menu.featured_products?.[node.collection_handle] || [];
      const cards = products.map(product => '<a class="desktop-product-card" href="' + loc(product.href) + '" title="' + product.title.replace(/"/g, '&quot;') + '"><img src="' + product.image + '" alt=""><span>' + product.title + '</span></a>').join('');
      return '<section class="desktop-product-shelf"><div class="desktop-product-shelf-head"><h3>' + node.label + '</h3><a href="' + href(node) + '">' + trh('view_all', 'View all →') + '</a></div><div class="desktop-product-grid">' + cards + '</div></section>';
    };
    const exploreAction = (url, icon, label, note) => '<a class="desktop-explore-action" href="' + loc(url) + '"><span>' + iconSvg(icon) + '</span><span><strong>' + label + '</strong><small>' + note + '</small></span>' + iconSvg('arrow-right') + '</a>';
    explore.innerHTML =
      '<div class="panel-title"><h2>' + trh('explore_artapli', 'Explore Artapli') + '</h2><a href="' + LP + '/collections">' + trh('return_all_designs', 'Return to all designs →') + '</a></div>' +
      '<div class="desktop-explore-grid">' +
        '<div class="desktop-explore-collections">' + productShelf(newArrivals) + productShelf(bestSellers) + '</div>' +
        '<div class="desktop-explore-actions">' +
          exploreAction('/blogs/try', 'gift', trh('free_samples', 'Free Samples'), trh('free_samples_note', 'Try an Artapli design before choosing')) +
          exploreAction('/pages/stitch-share-gallery', 'images', trh('customer_gallery', 'Customer Gallery'), trh('customer_gallery_note', 'See finished projects from the community')) +
          exploreAction('#', 'eye', trh('influencer_videos', 'Influencer Videos'), trh('influencer_videos_note', 'Watch designs stitched and styled')) +
        '</div>' +
        '<a class="desktop-explore-suggest" href="' + LP + '/pages/your-ideas-our-craft-suggest-a-design">' + iconSvg('lightbulb') + '<h3>' + trh('make_next', 'What should we make next?') + '</h3><p>' + trh('make_next_text', 'Send your embroidery idea. Strong customer requests can become future Artapli designs.') + '</p><strong>' + trh('suggest_design', 'Suggest a Design') + '</strong></a>' +
      '</div>' +
      '<div class="desktop-explore-footer"><a href="' + LP + '/pages/faq">' + trh('faq', 'FAQ') + '</a><a href="' + LP + '/blogs/studio-help">' + trh('studio_help', 'Studio Help') + '</a><a href="' + LP + '/pages/about">' + trh('about', 'About') + '</a><a href="' + LP + '/pages/how-to-purchase">' + trh('how_to_buy', 'How to Buy') + '</a><a href="' + LP + '/blogs/stitch-stories">' + trh('blog', 'Blog') + '</a><a href="' + LP + '/blogs/how-to-make">' + trh('how_to_make', 'How to Make') + '</a><a href="' + LP + '/blogs/embroidery-technical-reference">' + trh('technical_reference', 'Technical Reference') + '</a></div>';
    const nodeMedia = (node, fallbackIcon = 'folder') => nodeImage(node) ? '<img src="' + nodeImage(node) + '" alt="">' : iconSvg(fallbackIcon);
    const nodeThumb = node => '<span class="mobile-catalog-thumb">' + nodeMedia(node) + '</span>';
    const iconFeature = (url, icon, label) => '<a class="mobile-feature" href="' + loc(url) + '"><span class="mobile-feature-art mobile-graphic-art"><span class="mobile-feature-icon">' + (icon === 'font-aa' ? '<span class="mobile-main-font-mark" aria-hidden="true">Aa</span>' : iconSvg(icon)) + '</span></span><span class="mobile-feature-label"><strong>' + label + '</strong>' + iconSvg('arrow-right') + '</span></a>';
    const shopIndexLink = node => '<a href="' + href(node) + '"><span>' + node.label + '</span>' + iconSvg('arrow-right') + '</a>';
    const circleRow = (items, className = '') => '<div class="mobile-circle-row ' + className + '">' + items.map(item => '<a class="mobile-circle-link" href="' + loc(item[1]) + '"><span class="mobile-circle-art">' + (item[3] ? '<img src="' + item[3] + '" alt="">' : iconSvg(item[2])) + '</span><span>' + item[0] + '</span></a>').join('') + '</div>';
    const quickBlock = (title, items) => '<details class="mobile-icon-more"><summary><span>' + title + '</span>' + iconSvg('chevron-down') + '</summary>' + circleRow(items) + '</details>';
    const catalogNode = node => {
      const children = node.children.filter(child => child.visibility === 'visible');
      if (!children.length) return '<a class="mobile-catalog-leaf" href="' + href(node) + '">' + nodeThumb(node) + '<span>' + node.label + '</span></a>';
      return '<details class="mobile-catalog-branch"><summary>' + nodeThumb(node) + '<span>' + node.label + '</span>' + iconSvg('chevron-down') + '</summary><div class="mobile-catalog-children">' + children.map(catalogNode).join('') + '</div></details>';
    };
    const catalogIcons = new Map([['Fonts & Monograms','type'],['Shop by Technique','scissors'],['All Holidays','calendar'],['Shop by Theme','shapes']]);
    const rootByLabel = label => menu.product_tree.find(node => node.label === label);
    const absorbedPlacement = mobileRules.absorb_before || {};
    const withAbsorbedRoot = (primaryLabel, absorbedLabels = []) => {
      const primary = rootByLabel(primaryLabel);
      if (!primary) return null;
      const absorbed = absorbedLabels.map(rootByLabel).filter(Boolean);
      const children = [...primary.children];
      absorbed.forEach(node => {
        const beforeLabel = absorbedPlacement[node.label];
        const beforeIndex = beforeLabel ? children.findIndex(child => child.label === beforeLabel) : -1;
        children.splice(beforeIndex >= 0 ? beforeIndex : children.length, 0, node);
      });
      return { ...primary, children };
    };
    const catalogRootLabels = mobileRules.catalog_roots || ['Fonts & Monograms','Shop by Technique','All Holidays','Shop by Theme'];
    const absorbedRoots = mobileRules.absorb_roots || {'Fonts & Monograms':['Special Fonts'],'Shop by Technique':['Shop in the Hoop']};
    const mobileCatalogRoots = catalogRootLabels.map(label => withAbsorbedRoot(label, absorbedRoots[label] || [])).filter(Boolean);
    const shopIndexNodes = (mobileRules.shop_index || ['view-all','all-fonts']).map(findNodeByHandle).filter(Boolean);
    const featuredNodes = (mobileRules.featured || ['new-arrivals','best-sellers','most-reviewed']).map(findNodeByHandle).filter(Boolean);
    const featureIcons = new Map([['new-arrivals','sparkles'],['best-sellers','star'],['most-reviewed','message-square-heart']]);
    const catalogCircles = '<div class="mobile-circle-row">' + mobileCatalogRoots.map((node, index) => '<button class="mobile-circle-button" type="button" data-catalog-index="' + index + '" aria-selected="false"><span class="mobile-circle-art">' + nodeMedia(node, catalogIcons.get(node.label_en || node.label) || 'folder') + '</span><span class="mobile-circle-label"><span>' + node.label + '</span><span class="mobile-circle-arrow" aria-hidden="true">›</span></span></button>').join('') + '</div>';
    mobileMenu.className = 'mobile-menu mobile-menu-v4';
    mobileMenu.innerHTML =
      '<section class="mobile-hub"><div class="mobile-hub-head"><h2>' + trh('shop_designs', 'Shop Designs') + '</h2></div><div class="mobile-shop-index">' +
        shopIndexNodes.map(shopIndexLink).join('') +
      '</div><div class="mobile-feature-grid">' +
        featuredNodes.map(node => iconFeature(href(node), featureIcons.get(node.collection_handle) || 'sparkles', node.label)).join('') +
      '</div>' +
      '<div class="mobile-quick">' + catalogCircles + '<div class="mobile-catalog-panel" data-mobile-catalog-panel hidden></div></div></section>' +
      '<section class="mobile-hub"><div class="mobile-hub-head"><h2>' + trh('apps', 'Apps') + '</h2><a href="' + LP + '/pages/apps">' + trh('all_apps', 'All apps') + '</a></div><div class="mobile-feature-grid">' +
        iconFeature('/apps/artapli-studio/studio-entry?return_path=%2Flibrary%2F', 'library', trh('library', 'Library')) +
        iconFeature('/apps/artapli-studio/studio-entry?return_path=%2Flettering-v3%2F', 'lettering', trh('embroidery_editor', 'Embroidery Editor')) +
        iconFeature('/apps/artapli-studio/studio-entry?return_path=%2Flibrary%2Fmockup%2F', 'image', trh('mockup', 'Mockup')) +
      '</div>' +
      quickBlock(trh('more_apps', 'More Apps'), [
        [trh('design_preview', 'Design Preview'), '/pages/embroidery-previewer-app', 'eye'], [trh('zip_manager', 'ZIP Manager'), '/pages/app-embroidery-analyzer', 'folder'],
        [trh('dst_optimizer', 'DST Optimizer'), '/pages/dst-optimizer', 'zap'], [trh('smart_print', 'Smart Print'), '/pages/print-my-design-at-100-scale', 'printer'],
        [trh('svg_converter', 'SVG Converter'), '/pages/svg-creator', 'shapes'], [trh('thread_colors', 'Thread Colors'), '/pages/thread-color-picker', 'palette'], [trh('studio_help', 'Studio Help'), '/blogs/studio-help', 'circle-help']
      ]) + '</section>' +
      '<section class="mobile-hub"><div class="mobile-hub-head"><h2>' + trh('account', 'Account') + '</h2></div><div class="mobile-feature-grid">' +
        iconFeature('/pages/my-favorites', 'heart', trh('my_favorites', 'My Favorites')) +
        iconFeature('/apps/artapli-studio/studio-entry?return_path=%2Flibrary%2F', 'library', trh('my_library', 'My Library')) +
        iconFeature('https://account.artapli.shop/orders', 'package-check', trh('my_purchases', 'My Purchases')) +
      '</div>' +
      quickBlock(trh('profile_cart_contact', 'Profile, Cart & Contact'), [
        [trh('profile', 'Profile'), 'https://artapli.shop/customer_authentication/redirect', 'user'], [trh('cart', 'Cart'), '/cart', 'shopping-bag'], [trh('get_in_touch', 'Get in Touch'), '/pages/contact', 'message-circle']
      ]) + '</section>' +
      '<section class="mobile-hub"><div class="mobile-hub-head"><h2>' + trh('explore', 'Explore') + '</h2></div><div class="mobile-feature-grid">' +
        iconFeature('/blogs/try', 'gift', trh('free_samples', 'Free Samples')) +
        iconFeature('/pages/stitch-share-gallery', 'images', trh('customer_gallery', 'Customer Gallery')) +
        iconFeature('/pages/your-ideas-our-craft-suggest-a-design', 'lightbulb', trh('suggest_design', 'Suggest a Design')) +
      '</div>' +
      quickBlock(trh('explore_more', 'Explore more'), [
        [trh('faq', 'FAQ'), '/pages/faq', 'circle-help'], [trh('studio_help', 'Studio Help'), '/blogs/studio-help', 'book-open'], [trh('about', 'About'), '/pages/about', 'info'], [trh('blog', 'Blog'), '/blogs/stitch-stories', 'newspaper'],
        [trh('how_to_make', 'How to Make'), '/blogs/how-to-make', 'book-open'], [trh('how_to_buy', 'How to Buy'), '/pages/how-to-purchase', 'shopping-bag'],
        [trh('technical_reference', 'Technical Reference'), '/blogs/embroidery-technical-reference', 'library']
      ]) +
      '<a class="mobile-subscribe" href="' + LP + '/pages/subscribe"><strong>' + trh('stay_inspired', 'Stay inspired') + '</strong><span>' + trh('stay_inspired_text', 'New designs, helpful tools and practical embroidery guidance — delivered from Artapli.') + '</span></a></section>';
    const catalogPanel = mobileMenu.querySelector('[data-mobile-catalog-panel]');
    const selectMobileCatalog = selectedButton => {
      mobileMenu.querySelectorAll('[data-catalog-index]').forEach(other => {
        const selected = other === selectedButton;
        other.setAttribute('aria-selected', String(selected));
        other.querySelector('.mobile-circle-arrow').textContent = selected ? '⌄' : '›';
      });
    };
    mobileMenu.querySelectorAll('[data-catalog-index]').forEach(button => button.addEventListener('click', () => {
      const alreadyOpen = button.getAttribute('aria-selected') === 'true' && !catalogPanel.hidden;
      if (alreadyOpen) {
        selectMobileCatalog(null);
        catalogPanel.hidden = true;
        catalogPanel.innerHTML = '';
        return;
      }
      const node = mobileCatalogRoots[Number(button.dataset.catalogIndex)];
      selectMobileCatalog(button);
      const nodeLink = href(node) !== '#' ? '<a href="' + href(node) + '">' + trh('view_all', 'View all →') + '</a>' : '';
      catalogPanel.innerHTML = '<div class="mobile-catalog-panel-head' + (nodeLink ? ' has-link' : '') + '">' + nodeLink + '<button class="mobile-catalog-close" type="button" data-close-mobile-catalog aria-label="' + trh('close_catalog', 'Close catalog') + '">' + iconSvg('close') + '</button></div>' + node.children.filter(child => child.visibility === 'visible').map(catalogNode).join('');
      catalogPanel.hidden = false;
      catalogPanel.querySelector('[data-close-mobile-catalog]').addEventListener('click', () => {
        catalogPanel.hidden = true;
        catalogPanel.innerHTML = '';
        selectMobileCatalog(null);
      });
    }));
  }

  boot().then(() => {
    root.dataset.menuState = 'ready';
  }).catch(error => {
    root.dataset.menuState = 'fallback';
    console.error('[Artapli menu]', error);
  });
})();

/* ==== Header search suggestions, 2026-09-16 (Anna, d62: "верни мне мой поиск") ===============

   What was wrong. layout/theme.liquid renders {% render 'artapli-mega-menu-v2' %} and no longer
   renders {% sections 'header-group' %} at all, so sections/header.liquid - the section that used
   to render snippets/header-search.liquid, i.e. the theme's <predictive-search> element and
   assets/predictive-search.js - is not on any page any more. What the menu ships in its place is
   two plain GET forms, <form class="search" action="/search">, with no script behind them. That
   is why search "only works after Enter". settings.predictive_search_enabled is still true and
   /search/suggest.json still answers correctly; only the header lost its predictive layer.

   What this does. It gives those two existing forms Shopify's OWN predictive search back:
   GET /search/suggest.json?q=...&resources[type]=product,collection,page,article - the storefront
   route, same origin, no Admin API, no third party, no extra library and no extra font. The forms,
   the snippet and the prelaunch hide block are untouched, so with JS slow, broken or off the field
   still submits to /search exactly as it does today.

   Deliberate choices worth knowing:
   * The plate is appended as a direct child of #artapli-menu-v2, not inside the form, because
     `#artapli-menu-v2 .window` is overflow:hidden and would clip it. It is position:fixed and
     measured from the field. As a child of the root it still inherits the menu's own --ap-*
     tokens (BRAND.md: import, never copy).
   * Articles are filtered to the same blog handles sections/predictive-search.liquid allows, so
     the header agrees with the search page. See ALLOWED_ARTICLE_BLOGS - that list has drifted
     from the live blog handles and is a question for Anna, not something to quietly "fix" here.
   * Rows are built with textContent, never innerHTML, so a product title can never be markup.
   ========================================================================================== */

(() => {
  const root = document.getElementById('artapli-menu-v2');
  if (!root) return;
  /* i18n 2026-09-26: UI strings come from the snippet's JSON block (theme locale keys artapli_menu.js.*).
     Missing block or key -> the English fallback written here. */
  const I18N = (() => { try { const el = document.getElementById('artapli-menu-i18n'); return el ? JSON.parse(el.textContent) : {}; } catch (error) { return {}; } })();
  /* i18n phase 3: locale root from the JSON block ("/" on en -> LP is '' and every link stays as it was).
     loc() prefixes only root-relative store paths, never an already prefixed or external URL. */
  const LP = (() => { const r = typeof I18N.locale_root === 'string' ? I18N.locale_root : '/'; return r === '/' || r.charAt(0) !== '/' ? '' : r.replace(/\/+$/, ''); })();
  const loc = (url) => {
    if (!LP || typeof url !== 'string') return url;
    if (url.indexOf('/apps/artapli-studio/studio-entry') === 0) {
      try {
        const target = new URL(url, location.origin);
        const back = target.searchParams.get('return_path') || '/library/';
        if (!/[?&]lang=/.test(back)) {
          target.searchParams.set('return_path', back + (back.includes('?') ? '&' : '?') + 'lang=' + LP.slice(1, 3));
        }
        return target.pathname + target.search + target.hash;
      } catch (error) { return url; }
    }
    return /^\/(collections|pages|products|search|cart|account|blogs)(\/|\?|#|$)/.test(url) ? LP + url : url;
  };
  const decodeText = value => { const area = document.createElement('textarea'); area.innerHTML = value; return area.value; };
  const tr = (key, fallback, vars) => {
    let value = typeof I18N[key] === 'string' && I18N[key] && I18N[key].indexOf('translation missing') !== 0 ? decodeText(I18N[key]) : fallback;
    if (vars) Object.keys(vars).forEach(name => { value = value.split('{' + name + '}').join(vars[name]); });
    return value;
  };
  const trh = (key, fallback) => String(tr(key, fallback)).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  /* On /search the theme's own field is the one that owns predictive search, and the menu CSS
     already hides both header fields there. Nothing to enhance. */
  if (document.getElementById('Search-In-Template')) return;

  const SUGGEST_ROUTE = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  const DEBOUNCE_MS = 200;
  const MIN_CHARS = 2;
  const REQUEST_LIMIT = 6;              /* Shopify applies one limit to every resource type */
  const SHOW = { products: 6, collections: 3, pages: 2, articles: 3 };
  /* Copied verbatim from sections/predictive-search.liquid's allowed_search_blogs so the header
     and the search page show the same articles. NOTE for Anna: the live blog handles are
     how-to-make, tool-help, try, stitch-stories, embroidery-technical-reference and
     embroidery-design-guide - 'how-to' matches none of them, so in practice only tool-help and
     try can appear. Changing this list changes the search page too; it is her call. */
  const ALLOWED_ARTICLE_BLOGS = ['how-to', 'studio-help', 'try'];

  const money = value => {
    const amount = Number.parseFloat(value);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  };

  const priceLabel = product => {
    const low = money(product.price_min != null ? product.price_min : product.price);
    const high = money(product.price_max != null ? product.price_max : product.price);
    if (!low) return '';
    return high && high !== low ? low + ' – ' + high : low;
  };

  const thumbUrl = url => (url ? url + (url.includes('?') ? '&' : '?') + 'width=96' : '');
  const imageOf = node => (node.featured_image && node.featured_image.url) || node.image || '';

  const blogHandle = article => {
    const url = String(article.url || '').split('?')[0];
    if (!url.includes('/blogs/')) return '';
    return url.split('/blogs/')[1].split('/')[0];
  };

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };

  let counter = 0;

  function enhance(form) {
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || input.dataset.apSuggest === 'on') return;
    input.dataset.apSuggest = 'on';

    const id = 'ap-suggest-' + (counter += 1);
    const panel = element('div', 'ap-suggest');
    panel.id = id;
    panel.dataset.open = 'false';

    const list = element('div', 'ap-suggest-list');
    list.id = id + '-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', tr('search_suggestions', 'Search suggestions'));

    const scroll = element('div', 'ap-suggest-scroll');
    list.appendChild(scroll);

    const seeAll = document.createElement('a');
    seeAll.className = 'ap-suggest-all';
    seeAll.setAttribute('role', 'option');
    seeAll.setAttribute('aria-selected', 'false');
    seeAll.setAttribute('tabindex', '-1');
    seeAll.id = id + '-all';
    seeAll.appendChild(element('span', null, ''));
    seeAll.appendChild(element('span', null, '→'));
    list.appendChild(seeAll);

    const live = element('span', 'ap-suggest-live');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');

    panel.appendChild(list);
    panel.appendChild(live);
    root.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');

    const cache = new Map();
    let options = [];
    let active = -1;
    let controller = null;
    let timer = 0;
    let currentTerm = '';

    /* ---- geometry: the plate hangs under the field and never owns the whole phone screen ---- */
    function place() {
      const box = form.getBoundingClientRect();
      if (!box.width || !box.height) { close(); return; }
      const top = box.bottom + 6;
      const phone = window.matchMedia('(max-width:520px)').matches;
      const cap = phone ? Math.min(400, window.innerHeight * 0.58) : Math.min(560, window.innerHeight * 0.7);
      const room = window.innerHeight - top - 12;
      panel.style.top = Math.round(top) + 'px';
      panel.style.left = Math.round(box.left) + 'px';
      panel.style.width = Math.round(box.width) + 'px';
      panel.style.maxHeight = Math.round(Math.max(140, Math.min(cap, room))) + 'px';
    }
    const reposition = () => { if (panel.dataset.open === 'true') place(); };

    function open() {
      if (panel.dataset.open !== 'true') {
        panel.dataset.open = 'true';
        input.setAttribute('aria-expanded', 'true');
        window.addEventListener('resize', reposition);
        window.addEventListener('scroll', reposition, true);
      }
      place();
    }

    function close() {
      if (panel.dataset.open === 'false') return;
      panel.dataset.open = 'false';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      setActive(-1);
      window.removeEventListener('resize', reposition);
      window.removeEventListener('scroll', reposition, true);
    }

    function setActive(index) {
      active = index;
      options.forEach((option, position) => {
        const on = position === index;
        option.dataset.active = String(on);
        option.setAttribute('aria-selected', String(on));
      });
      if (index >= 0 && options[index]) {
        input.setAttribute('aria-activedescendant', options[index].id);
        options[index].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function move(step) {
      if (!options.length) return;
      const next = active < 0
        ? (step > 0 ? 0 : options.length - 1)
        : (active + step + options.length) % options.length;
      setActive(next);
    }

    /* ---- drawing ---------------------------------------------------------------------- */
    function resetSeeAll(term) {
      seeAll.href = LP + '/search?q=' + encodeURIComponent(term) + '&type=product';
      seeAll.firstChild.textContent = tr('see_all_results', 'See all results for “{term}”', { term });
    }

    function group(title, items, draw) {
      if (!items.length) return 0;
      const heading = element('h3', 'ap-suggest-label', tr('group_' + title, title));
      heading.id = id + '-label-' + title;
      const holder = element('div');
      const rows = element('div');
      rows.setAttribute('role', 'group');
      rows.setAttribute('aria-labelledby', heading.id);
      items.forEach(item => rows.appendChild(draw(item)));
      holder.appendChild(heading);
      holder.appendChild(rows);
      scroll.appendChild(holder);
      return items.length;
    }

    function row(node, extraClass, title, meta, withThumb) {
      const anchor = document.createElement('a');
      anchor.className = 'ap-suggest-row' + (extraClass ? ' ' + extraClass : '');
      anchor.href = loc(node.url || '#');
      anchor.setAttribute('role', 'option');
      anchor.setAttribute('aria-selected', 'false');
      anchor.setAttribute('tabindex', '-1');
      anchor.id = id + '-opt-' + (options.length);
      if (withThumb) {
        const thumb = element('span', 'ap-suggest-thumb');
        const letter = () => String(title || '').trim().charAt(0).toUpperCase() || '·';
        const url = imageOf(node);
        if (url) {
          const image = document.createElement('img');
          image.src = thumbUrl(url);
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          /* A picture that 404s, is blocked or never arrives must not leave a bare grey square:
             it degrades to the same neutral letter mark an item with no image gets. */
          image.addEventListener('error', () => { image.remove(); thumb.textContent = letter(); }, { once: true });
          thumb.appendChild(image);
        } else {
          thumb.textContent = letter();
        }
        anchor.appendChild(thumb);
      }
      const text = element('span', 'ap-suggest-text');
      text.appendChild(element('span', 'ap-suggest-title', title));
      if (meta) text.appendChild(element('span', 'ap-suggest-meta', meta));
      anchor.appendChild(text);
      options.push(anchor);
      return anchor;
    }

    function note(text, term) {
      const paragraph = element('p', 'ap-suggest-note');
      paragraph.appendChild(document.createTextNode(text));
      if (term) {
        paragraph.appendChild(document.createTextNode(' “'));
        paragraph.appendChild(element('strong', null, term));
        paragraph.appendChild(document.createTextNode('”.'));
      }
      scroll.appendChild(paragraph);
    }

    function clear() {
      scroll.textContent = '';
      options = [];
      active = -1;
    }

    function renderBusy(term) {
      clear();
      resetSeeAll(term);
      note(tr('searching_for', 'Searching for'), term);
      options.push(seeAll);
      setActive(-1);
      open();
    }

    function renderProblem(term) {
      clear();
      resetSeeAll(term);
      note(tr('suggestions_unavailable', 'Suggestions are not available right now — press Enter to search for'), term);
      options.push(seeAll);
      setActive(-1);
      open();
    }

    function render(term, payload) {
      clear();
      resetSeeAll(term);
      const results = (payload && payload.resources && payload.resources.results) || {};
      const products = (results.products || []).slice(0, SHOW.products);
      const collections = (results.collections || []).slice(0, SHOW.collections);
      const pages = (results.pages || []).slice(0, SHOW.pages);
      const articles = (results.articles || [])
        .filter(article => ALLOWED_ARTICLE_BLOGS.indexOf(blogHandle(article)) !== -1)
        .slice(0, SHOW.articles);

      let count = 0;
      count += group('products', products, product =>
        row(product, 'ap-suggest-row-product', product.title, priceLabel(product), true));
      count += group('collections', collections, collection =>
        row(collection, 'ap-suggest-row-collection', collection.title, '', true));
      count += group('pages', pages, page =>
        row(page, 'ap-suggest-row-page', page.title, '', false));
      count += group('articles', articles, article =>
        row(article, 'ap-suggest-row-article', article.title, '', false));

      if (!count) note(tr('no_results_for', 'No results found for'), term);
      options.push(seeAll);
      setActive(-1);
      live.textContent = count
        ? (count === 1 ? tr('results_one', '{count} result found for “{term}”', { count, term }) : tr('results_other', '{count} results found for “{term}”', { count, term }))
        : tr('results_none', 'No results found for “{term}”', { term });
      open();
    }

    /* ---- asking the storefront ---------------------------------------------------------- */
    function request(term) {
      if (controller) controller.abort();          /* the previous answer is no longer wanted */
      controller = new AbortController();
      const params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'product,collection,page,article');
      params.set('resources[limit]', String(REQUEST_LIMIT));
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      return fetch(SUGGEST_ROUTE + '.json?' + params.toString(), {
        signal: controller.signal,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(response => {
        if (!response.ok) throw new Error('suggest ' + response.status);
        return response.json();
      });
    }

    function ask(term) {
      currentTerm = term;
      if (cache.has(term)) { render(term, cache.get(term)); return; }
      renderBusy(term);
      request(term).then(payload => {
        cache.set(term, payload);
        if (input.value.trim() === term) render(term, payload);
      }).catch(error => {
        if (error && error.name === 'AbortError') return;
        if (input.value.trim() === term) renderProblem(term);
      });
    }

    input.addEventListener('input', () => {
      const term = input.value.trim();
      window.clearTimeout(timer);
      if (term.length < MIN_CHARS) {
        if (controller) controller.abort();
        close();
        return;
      }
      if (cache.has(term)) { ask(term); return; }
      timer = window.setTimeout(() => ask(term), DEBOUNCE_MS);
    });

    input.addEventListener('focus', () => {
      const term = input.value.trim();
      if (term.length >= MIN_CHARS && cache.has(term)) ask(term);
    });

    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (panel.dataset.open !== 'true') {
          const term = input.value.trim();
          if (term.length >= MIN_CHARS) ask(term);
          if (panel.dataset.open !== 'true') return;
        }
        event.preventDefault();
        move(event.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (event.key === 'Enter') {
        if (panel.dataset.open === 'true' && active >= 0 && options[active]) {
          event.preventDefault();                  /* otherwise the form submits underneath us */
          const href = options[active].href;
          close();
          window.location.assign(href);
        }
        return;                                    /* no active row: the form submits to /search */
      }
      if (event.key === 'Escape') {
        if (panel.dataset.open === 'true') {
          event.preventDefault();
          event.stopPropagation();                 /* Escape closes the plate before the drawer */
          close();
        }
        return;
      }
      if (event.key === 'Tab') close();
    });

    /* Keep the caret in the field while a row is pressed: click still fires and the anchor
       still navigates, but the plate does not close under the finger first. */
    panel.addEventListener('pointerdown', event => event.preventDefault());
    panel.addEventListener('click', () => close());
    form.addEventListener('submit', () => close());
    document.addEventListener('pointerdown', event => {
      if (!panel.contains(event.target) && !form.contains(event.target)) close();
    });
  }

  root.querySelectorAll('form.search').forEach(enhance);
})();
